import { DomHelper } from '../utils/dom-helper'
import { UrlHelper } from '../utils/url-helper'
import { FilterBarFormHandler } from './filter-bar-form-handler'

/**
 * Componente responsável por barra de filtro simples.
 */

export class FilterBar {

  /* consts */

  static INPUT_CHANGE_SELECTORS = 'select, input[type=checkbox], [data-filter-bar-field]'

  constructor(aFilterBarContainer) {
    /* globals */

    const self = this

    this._domFilterBarContainer = aFilterBarContainer
    this._domHelper = new DomHelper(this._domFilterBarContainer)
    this._domFilterForm = this._domFilterBarContainer.querySelector('form')
    this._formHandler = new FilterBarFormHandler(this._domFilterBarContainer, this)
    this._urlHelper = new UrlHelper()
    this._initEventHandlers()

    aFilterBarContainer._filterBar = this
  }

  /* public API */

  clearFilter() {
    this._formHandler.clearFilter()
  }

  getFilterBarId() {
    return this._getFilterBarId()
  }

  submitForm() {
    this._formHandler.submitForm()
  }

  submitFormWithoutHistory() {
    this._formHandler.submitFormWithoutHistory()
  }

  updateUrl() {
    this._formHandler.updateUrl()
  }

  getFormParameters() {
    return this._formHandler.getFormParameters()
  }

  /* event handlers */

  // history.back...

  _initEventHandlers() {

    let self = this

    window.addEventListener('popstate', function(aEvent) {
      // aEvent.target.location.search = parametros da url antiga que está sendo 'popped'
      // ex: ?cod_gestora=+&data_assinatura=&data_publicacao_portal=&decricao_modalidade=+&page=17&search=&sort_column=integration_supports_creditors.nome&sort_direction=desc&status=+&tipo_objeto=+

      const stateData = aEvent.state,
        filterBarId = stateData?.filter_bar_id,
        turboRestoration = stateData?.turbo?.restorationIndex === 0,
        reload = (stateData?.reload || turboRestoration),
        params = self._urlHelper.getUrlParams(aEvent.target.location.search)

      if (reload) {
        // Para o backbutton funcionar nas ferramentas que usam pushState

        self._restoreFormParameters(params)
        self.submitFormWithoutHistory()
      }

      if (filterBarId === self._getFilterBarId()) {
        self._restoreFormParameters(params)
      }

    }, true)

    // usuário clicou no botão de limpar o filtro...

    this._domFilterBarContainer.addEventListener('click', (aEvent) => {

      if (aEvent.target.matches('button[type=reset]')) {
        self._formHandler.clearFilter()
      }
    })

    // usuário mudou alguma opção de filtro em select...

    $(this._domFilterBarContainer).on('change', FilterBar.INPUT_CHANGE_SELECTORS, (aEvent) => {
      if (self._considerInputChanged(aEvent.target)) {
        self._formHandler.submitForm()
      }
    })

    // usuário pressionou enter no campo de busca...

    this._domFilterBarContainer.addEventListener('keyup', (aEvent) => {
      if (aEvent.target.matches('input[type=text]')) {
        self._formHandler.handleKeyUp(aEvent)
      }
    })

  }

  /* privates */

  _restoreFormParameters(aParams) {
    this._formHandler.restoreFormParameters(aParams)
  }

  _considerInputChanged(aInput) {
    // temos que ignorar os changes enquanto estiver limpando filtros do select2
    // pois é necessário dar um trigger nessa merda de componente.
    if (this._formHandler.isClearingFilters() || this._ignoreChange(aInput) || this._disabledAutoSubmit()) {
      return false
    }

    return (aInput.getAttribute('data-filter-bar-ignore') !== 'true')
  }

  _getFilterBarId() {
    return this._domFilterBarContainer.getAttribute('data-filter-bar')
  }

  _ignoreChange(aInput) {
    return (aInput.getAttribute('data-ignore-filter-bar-change') === 'true')
  }

  _disabledAutoSubmit() {
    return (this._domFilterBarContainer.getAttribute('data-disable-auto-submit') === 'true')
  }
}
